import Dexie, { type Table } from "dexie";
import type { MarkerRecord, MetaRecord, OutboxRecord, ProgressRecord } from "./types";

export class PplEnglishDB extends Dexie {
  // Phase 2 / Issue #95: Primary Key wurde von `english` auf `[english+direction]`
  // erweitert. Dexie verwaltet das automatisch — TypeScript-Index-Typ bleibt
  // string (Dexie composite PKs werden als Array gehandhabt).
  progress!: Table<ProgressRecord, [string, string]>;
  meta!: Table<MetaRecord, string>;
  outbox!: Table<OutboxRecord, number>;
  /** v5 (Issue #123): markierte Vokabeln; global pro Wort, nicht pro Direction. */
  markers!: Table<MarkerRecord, string>;

  constructor() {
    super("ppl-english-trainer");
    this.version(1).stores({
      progress: "english, state, earliestQuestionIndex",
      meta: "key",
    });
    this.version(2).stores({
      progress: "english, state, earliestQuestionIndex",
      meta: "key",
      outbox: "++id, status, ts",
    });
    // v3 (Issue #95): die alte progress-Tabelle droppen, weil Dexie keinen
    // PK-Wechsel via upgrade() unterstützt ("Not yet support for changing
    // primary key"). v4 legt die Tabelle mit Compound-PK [english+direction]
    // neu an.
    //
    // Lokaler Datenverlust durch das Drop ist akzeptabel:
    //  - Authed User: store.loadAll → hydrateFromServer rebuildet IDB aus den
    //    server-seitigen direction-aware Progress-Rows (Phase-1-Migration hat
    //    alle Server-Rows auf direction='en_de' gesetzt; Phase-2-ensureSeeded
    //    ergänzt fehlende de_en-Rows).
    //  - Unauthed: ensureSeeded seedet beide Richtungen frisch.
    this.version(3).stores({
      progress: null,
      meta: "key",
      outbox: "++id, status, ts",
    });
    this.version(4).stores({
      progress: "[english+direction], state, direction, earliestQuestionIndex",
      meta: "key",
      outbox: "++id, status, ts",
    });
    // v5 (Issue #123): neuer Store für markierte Vokabeln. Keine Veränderung
    // an den existierenden Stores — additive Migration, kein Datenverlust.
    // `&english` = `english` ist Unique-Primary-Key.
    this.version(5).stores({
      progress: "[english+direction], state, direction, earliestQuestionIndex",
      meta: "key",
      outbox: "++id, status, ts",
      markers: "&english,createdAt",
    });
  }
}

export const db = new PplEnglishDB();
